/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContractingState = 'Undefined' | 'ColectingData' | 'AdditingDataPrintFailed' | 'DocumentPrintFailed' | 'DocumentSentToSignOK' | 'DocumentSentToSignFailed' | 'DocumentSignedFailed' | 'AdditingDataApiFailed' | 'SentToFlexiOK' | 'SentToFlexiFailed' | 'ContractingComplete' | 'ContractingFailed' | 'Cancelled' | 'WaitingForApprovalAfterCustomerSign' | 'CollectingDataByAdmin';

export const ContractingState = {
    Undefined: 'Undefined' as ContractingState,
    ColectingData: 'ColectingData' as ContractingState,
    AdditingDataPrintFailed: 'AdditingDataPrintFailed' as ContractingState,
    DocumentPrintFailed: 'DocumentPrintFailed' as ContractingState,
    DocumentSentToSignOK: 'DocumentSentToSignOK' as ContractingState,
    DocumentSentToSignFailed: 'DocumentSentToSignFailed' as ContractingState,
    DocumentSignedFailed: 'DocumentSignedFailed' as ContractingState,
    AdditingDataApiFailed: 'AdditingDataApiFailed' as ContractingState,
    SentToFlexiOK: 'SentToFlexiOK' as ContractingState,
    SentToFlexiFailed: 'SentToFlexiFailed' as ContractingState,
    ContractingComplete: 'ContractingComplete' as ContractingState,
    ContractingFailed: 'ContractingFailed' as ContractingState,
    Cancelled: 'Cancelled' as ContractingState,
    WaitingForApprovalAfterCustomerSign: 'WaitingForApprovalAfterCustomerSign' as ContractingState,
    CollectingDataByAdmin: 'CollectingDataByAdmin' as ContractingState,
};